import styled from 'styled-components'
import { colors } from '@entur/tokens'
import { IconButton } from '@entur/button'

export const MenuBtn = styled(IconButton)`
  border: 1px solid ${colors.blues.blue60};
  border-radius: 0.25rem;
  background: none;
  cursor: pointer;
  justify-content: center;
  align-items: center;
  height: 2rem;
  width: 2rem;
  font-size: 1rem;
  padding: 0.5rem;
  :hover & :focus {
    background-color: #d1d4e3;
    border: 1px solid ${colors.blues.blue60};
    outline: none;
  }
  :hover {
    background-color: #d1d4e3;
    border: 1px solid ${colors.blues.blue60};
  }
  :focus {
    background-color: #d1d4e3;
    outline: none;
  }
`
